import themes from "./themes";
import { useThemeSelector } from "./useThemeSelector";

export default { ...themes, useThemeSelector };
